import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { accountTypes, AgreementId, AgreementSignatureStatusOptions, AgreementSignatureTypes, SignatureRequestId, } from "../../Types";
import ValidationError from "../../ZodError";
const Agreement = z.object({
    accountType: z.enum(accountTypes).nullable(),
    agreementId: AgreementId,
    dateAdded: z.string(),
    documentTitle: z.string(),
    signatureRequestId: SignatureRequestId.nullable(),
    signatureType: z.enum(AgreementSignatureTypes),
    status: z.enum(AgreementSignatureStatusOptions),
});
const Response = Agreement.array();
export const url = () => environment() === "PROD"
    ? `https://middleware.prod.farther.com/doc/document-center/tasks`
    : `https://middleware.uat.farther.com/doc/document-center/tasks`;
export default async function getAgreements(config) {
    const { data } = await axios.get(url(), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getAgreements] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAgreements.js.map